import React from "react";
import Header from "../SharedSection/Header/Header";
import Skills from "./Skills/Skills";

const AboutMe = () => {
    return (
        <div>
            <Header />
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6 col-sm-12 mt-5">
                        <div className="bg-dark pb-0 p-2 shadow-lg">
                            <img
                                className="img-fluid border-bottom"
                                src="https://i.ibb.co/PDZqbHm/Abstract-form-of-fluid-1.png"
                                alt="my_pic"
                            />
                        </div>
                    </div>
                    <div className="text-start col-md-6 col-sm-12 p-4">
                        <h1 className="text-bolder">About</h1>
                        <p className="fs-5">
                            Hi, I'm Naimur Rahman.I'm a web developer from
                            Bangladesh. I am a JavaScript based Developer with
                            React Projects develop experiences with Node and
                            mongoDB.
                        </p>
                        <p>
                            worked to make a better web. Build fast, easy to
                            use, beautiful, accessible to all, and
                            frustration-free web apps with your specific
                            requirements for can you finding success online.
                        </p>

                        <p>
                            My main experiences in building MERN Stack
                            development but I also have a knowledge design that
                            Given to producing a modern website requires the
                            combination of interactivity and server technology.
                            I believe having experience in both design and
                            development allows for making the most optimal user
                            experiences.
                        </p>
                        <p>
                            Used HTML and CSS for template, feel comfortable to
                            make Web application with ReactJS, NodeJS,
                            ExpressJS. Used mangoDB for store data, css
                            frameworks implement to responsive websites and web
                            apps.Responsiveness provides user the most
                            appropriate experience suited to their device and
                            browser.
                        </p>
                    </div>
                </div>
                <div className="row g-3">
                    <div className="col-sm-12 col-md-6">
                        <h2>Academic Education</h2>
                        <div className="row g-2 text-start bg-dark m-2 p-2 rounded">
                            <div className="col-3">
                                <img
                                    className="img-fluid"
                                    src="https://media-exp1.licdn.com/dms/image/C510BAQFbYYtS6siQBw/company-logo_100_100/0/1519871396662?e=1646265600&v=beta&t=zTUWsYB1YvyIq5ai8hGzA00hstenKTs375PtVrvM8Dg"
                                    alt=""
                                />
                            </div>
                            <div className="col-8">
                                <p className="fs-5 m-0">
                                    National University | Bangladesh
                                </p>
                                <p className="m-0">
                                    Bachelor of Science - BS, Botany.
                                </p>
                                <small className="text-secondary">2021</small>
                            </div>
                        </div>
                        <div className="row g-2 text-start bg-dark m-2 p-2 rounded">
                            <div className="col-3">
                                <img
                                    className="img-fluid"
                                    src="https://govmmalicollege.edu.bd/wp-content/uploads/2019/09/MM-Ali-College-logo-1-100x102.png"
                                    alt=""
                                />
                            </div>
                            <div className="col-8">
                                <p className="fs-5 m-0">
                                    Govt. M. M. Ali College, Tangail.
                                </p>
                                <p className="m-0">HSC, Science</p>
                                <small className="text-secondary">
                                    2018-2020
                                </small>
                            </div>
                        </div>
                        <div className="row g-2 text-start bg-dark m-2 p-2 rounded">
                            <div className="col-3">
                                <img
                                    className="img-fluid"
                                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                    alt="Jahnavi_School"
                                />
                            </div>
                            <div className="col-8">
                                <p className="fs-5 m-0">
                                    Santosh Jahnavi High School
                                </p>
                                <p className="m-0">SSC, Science</p>
                                <small className="text-secondary">
                                    2016-2018
                                </small>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <h2>Courses</h2>
                        <div className="container-fluid ps-4">
                            <div className="row g-2 text-start border-Secondary m-2 p-2 rounded">
                                <div className="col-4">
                                    <img
                                        className="img-fluid"
                                        src="https://media-exp1.licdn.com/dms/image/C560BAQHepTIEBS5_rA/company-logo_100_100/0/1620187823846?e=1646265600&v=beta&t=23948iRe9rBVgq3tmKeGBVXxNdB75VtEZiz5cfCYKqc"
                                        alt="Programming_hero"
                                    />
                                </div>
                                <div className="col-7">
                                    <p className="fs-5 m-0">
                                        Complete Web Development Course With
                                        Jhankar Mahbub
                                    </p>
                                    <p className="m-0 text-warning">
                                        Programming Hero
                                    </p>
                                    <small className="text-secondary">
                                        2021
                                    </small>
                                </div>
                            </div>
                            <div className="row g-2 text-start border-Secondary m-2 p-2 rounded">
                                <div className="col-4">
                                    <img
                                        className="img-fluid"
                                        src="https://media-exp1.licdn.com/dms/image/C4E0BAQGLKj3JHcof0w/company-logo_100_100/0/1589990867649?e=1646265600&v=beta&t=N_Essase-RdH9DChVUtBvMrS8rYN98fAKK927-4O8Rw"
                                        alt="Programming_hero"
                                    />
                                </div>
                                <div className="col-7">
                                    <p className="fs-5 m-0">
                                        Responsive Web Design
                                    </p>
                                    <p className="m-0 text-warning">
                                        freeCodeCamp
                                    </p>
                                    <small className="text-secondary">
                                        2021
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Skills />
            </div>
        </div>
    );
};

export default AboutMe;
